import {AuthService} from "../libs/Auth";
import { AdminModel } from "../models/AdminModel";

export class AdminCtrl{
    public static $inject = ['$scope', 'AuthService', 'AdminModel'];
    constructor(public $scope: any, public authService: AuthService, public model: AdminModel) {
        $scope.vm = this;
    }
}
